import { app } from 'app/app';
import { AppController } from 'app/controller';
import { user } from 'app/user';
import { userWatchlist } from 'app/userWatchlist';
import { mediaQueries } from 'util/mediaQueries';
import { MasterLayout } from 'layout/master/main';
import { JobDetailContent } from 'module/jobDetailContent/main';
import { hasConsentGrantedOrDenied, onConsentChange } from 'util/consent';
import './styles.scss';

/**
 * Re: Vue in k4.
 * The first major deploy failed due to node's single-threaded nature, but we don't want to do a complete revert.
 * As to not completely block development we need to support the old legacy system while still allowing easy migration
 * to Vue. For this purpose the old system is used by default and Vue is only loaded and used if an env flag allows
 * it, which keeps the bundle lightweight.
 *
 * Once Vue is running successfully on production, the old legacy system should be removed and the separate
 * vue-entry file should be inlined into this file.
 */

class JobDetail extends AppController {
    ready() {
        this.initHistoryApi();
        this.sendAdWordsTracking();
        this.sendShowEvents();
    }

    onPopState(state) {
        if (!state) return; // hashbang fix
        const shareModalActive = state.shareModalOpen ? state.shareModalOpen : false;

        if (mediaQueries.isMobile()) {
            if (shareModalActive) {
                this.jobDetail.openShareModal();
            } else if (this.jobDetail.isShareModalOpen()) {
                this.jobDetail.closeShareModal();
            }
        }
    }

    domBindings() {
        return {
            jobDetail: '.m-jobDetailContent',
        };
    }

    subs() {
        this.layout = new MasterLayout(document.documentElement);
        this.jobDetail = new JobDetailContent(this.dom.jobDetail);
    }

    subEvents() {
        if (hasConsentGrantedOrDenied()) {
            this.jobDetail.allowPointerEvents();
        }
        onConsentChange(() => {
            if (hasConsentGrantedOrDenied()) {
                this.jobDetail.allowPointerEvents();
            }
        });
        if (this.dom.jobDetail) {
            this.jobDetail.events.on('toggleContent', () => {
                this.toggleContent();
            });

            this.jobDetail.events.on('pushState', () => {
                const props = { ...this.getProps() };
                props.shareModalOpen = true;
                this.pushState(props, document.title, window.location.href);
            });

            this.jobDetail.events.on('addShareModalStyles', () => {
                this.layout.addModalStyle();
                window.document.querySelector('.c-jobDetail')
                    .classList.add('c-jobDetail--openModal');
            });

            this.jobDetail.events.on('removeShareModalStyles', () => {
                this.layout.removeModalStyle();
                window.document.querySelector('.c-jobDetail')
                    .classList.remove('c-jobDetail--openModal');
            });

            this.jobDetail.events.on('addModalStyle', () => {
                this.layout.addModalStyle();
            });

            this.jobDetail.events.on('removeModalStyle', () => {
                this.layout.removeModalStyle();
            });
        }
        if (!user.isLoggedIn()) {
            userWatchlist.events.on('onUnauthorized', (watchlistObject) => {
                this.layout.openLoginModal(watchlistObject.arguments[0].watchlistObject.state, true, true);
            });
        }
    }

    toggleContent() {
        this.jobDetail.render();
    }

    sendShowEvents() {
        if (this.jobDetail) this.jobDetail.sendShowEvents();
    }

    sendAdWordsTracking() {
        window.dataLayer.push({
            googleAdsData: {
                job_pagetype: 'offerdetail',
                job_id: this.jobDetail.props.jobContent.id,
            },
        });
    }
}

// Defined in build tool
// eslint-disable-next-line no-undef
if (VUE_ENABLED) {
    import('./vue-entry');
} else {
    app.boot(JobDetail);

    if (module.hot) {
        module.hot.accept(module.children, () => {
            // eslint-disable-next-line no-console
            console.log('Rebooting controller due to HMR...');
            app.boot(JobDetail);
        });

        module.hot.accept(() => {});
    }
}
